export default "__VITE_ASSET__jvdEjGJC__"